import React from 'react';
import { AoInspectieOverspanningenUnitCode } from '../../../../../common/src/domain/customInspectionTypes/amsterdamOverspanningen/inspectieOverspanningen/AoInspectieOverspanningenUnitCode';
import { CollapsiblePanel, EditPanel, EditPanelCellLabel, EditPanelRow, PanelBody, Tray } from '../../../components/elements';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditAoInspectieOverspanningenUnitAansluitkast } from './SurveyEditAoInspectieOverspanningenUnitAansluitkast';
import { SurveyEditAoInspectieOverspanningenUnitArmatuur } from './SurveyEditAoInspectieOverspanningenUnitArmatuur';
import { SurveyEditAoInspectieOverspanningenUnitGevelbevestiging } from './SurveyEditAoInspectieOverspanningenUnitGevelbevestiging';
import { SurveyEditAoInspectieOverspanningenUnitMastbevestiging } from './SurveyEditAoInspectieOverspanningenUnitMastbevestiging';
import { SurveyEditAoInspectieOverspanningenUnitSpandraadsysteem } from './SurveyEditAoInspectieOverspanningenUnitSpandraadsysteem';

export function SurveyEditAoInspectieOverspanningenUnit(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateUnitData,
) {
    if (props.unitCode === AoInspectieOverspanningenUnitCode.Aansluitkast) {
        return <SurveyEditAoInspectieOverspanningenUnitAansluitkast {...props} />;
    }
    if (props.unitCode === AoInspectieOverspanningenUnitCode.Gevelbevestiging) {
        return <SurveyEditAoInspectieOverspanningenUnitGevelbevestiging {...props} />;
    }
    if (props.unitCode === AoInspectieOverspanningenUnitCode.Mastbevestiging) {
        return <SurveyEditAoInspectieOverspanningenUnitMastbevestiging {...props} />;
    }
    if (props.unitCode === AoInspectieOverspanningenUnitCode.Spandraadsysteem) {
        return <SurveyEditAoInspectieOverspanningenUnitSpandraadsysteem {...props} />;
    }
    if (props.unitCode === AoInspectieOverspanningenUnitCode.Armatuur) {
        return <SurveyEditAoInspectieOverspanningenUnitArmatuur {...props} />;
    }

    const allowedUnitCodes = [
        AoInspectieOverspanningenUnitCode.Aansluitkast,
        AoInspectieOverspanningenUnitCode.Gevelbevestiging,
        AoInspectieOverspanningenUnitCode.Mastbevestiging,
        AoInspectieOverspanningenUnitCode.Spandraadsysteem,
        AoInspectieOverspanningenUnitCode.Armatuur,
    ];

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <CollapsiblePanel heading={{ dark: true, text: `${props.unitName} details` }}>
                    <PanelBody isForm={true}>
                        <EditPanelRow>
                            <EditPanelCellLabel
                                rowCount={10}
                                text={`Onbekende unit code "${props.unitCode}", alleen codes ${allowedUnitCodes.join(',')} zijn toegestaan.`}
                            ></EditPanelCellLabel>
                        </EditPanelRow>
                    </PanelBody>
                </CollapsiblePanel>
            </EditPanel>
        </Tray>
    );
}
